import { render } from "./GridOportunitati.vue?vue&type=template&id=00cc6002&ts=true"
import script from "./GridOportunitati.vue?vue&type=script&lang=ts"
export * from "./GridOportunitati.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__